module.exports = __webpack_public_path__ + "08514f6ba60260a6b121442b28746886.pdf";